// @flow
import React, { Component } from 'react'
import moment from 'moment'
import {StyledCard} from './style'
import { Card, Table, Button, Input, Select, InputNumber, DatePicker } from 'antd'
import {getPositionsData} from '../../utils/tradeTransactions';
import {ConvertTransactionToPositions} from '../../utils/TradeCalculations';
const Option = Select.Option;

type Props = {
  targetTrade: Object,
  checkedList: number[],
  onCheckedChange: number[] => void
}

const tradeType = {
  0: 'Call',
  1: 'Put'
};

class TableRiskSelected extends Component<Props> {
  
  state = {
    editableIndexes: [],
  }
  
  onEdit = (index) => {
    const {editableIndexes} = this.state;
    editableIndexes.push(index);
    this.setState({
      editableIndexes,
    })
  }
  
  onCancel = (index) => {
    this.setState({
      editableIndexes: this.state.editableIndexes.filter(x=> x!==index ),
    })
  }
  
  // getPositions = (Transactions) => {
  //   const transactions = Transactions.filter(x => x.price && x.expiration).map(t => {
  //     return {
  //       Qty: parseInt(t.quantity),
  //       Multiplier: parseFloat(t.multipliper),
  //       OpenPrice: parseFloat(t.price),
  //       TradePrice: parseFloat(t.price),
  //       StockSymbol: t.underlying,
  //       OptionSymbol: t.symbol || t.underlying,
  //       Mark: parseFloat(t.marketPrice || t.mark),
  //       ExpirationDate: new Date(t.expiration),
  //       UnderlyingPrice: parseFloat(t.underlyingPrice),
  //       Strike: parseFloat(t.strike),
  //       TradeType: t.assetType === 'Call' ? 0 : 1,
  //       TradeDate: new Date(t.tradeDate),
  //       TradeSide: t.action,
  //       Commission: parseFloat(t.commission || 0),
  //       marketPrice: parseFloat(t.marketPrice || 0),
  //     }
  //   });
  //   const positions = getPositionsData(transactions);
  //   return positions.map(p => {
  //     return {
  //       ...p,
  //       OpenDate: p.OpenDate ? moment(p.OpenDate).format('YYYY-MM-DD') : null,
  //       CloseDate: p.CloseDate ? moment(p.CloseDate).format('YYYY-MM-DD') : null,
  //       isClosed: !!p.CloseDate,
  //       Qty: p.Quantity,
  //       TradeType: tradeType[p.TradeType || 0],
  //       Instrument: p.InstrumentDescription,
  //       Delta: p.Delta && !isNaN(p.Delta) ? p.Delta.toFixed(2) : '',
  //       Gamma: p.Gamma && !isNaN(p.Gamma) ? p.Gamma.toFixed(2) : '',
  //       Theta: p.Theta && !isNaN(p.Theta) ? p.Theta.toFixed(2) : '',
  //       Vega: p.Vega && !isNaN(p.Vega) ? p.Vega.toFixed(2) : '',
  //       ImpliedVolatility: p.ImpliedVolatility && !isNaN(p.ImpliedVolatility) ? p.ImpliedVolatility.toFixed(2) : '',
  //       DaysToExpire: p.DaysToExpire && !isNaN(p.DaysToExpire) ? p.DaysToExpire.toFixed(2) : '',
  //     }
  //   });
  // }

  render() {
    const editableIndexes = this.state.editableIndexes;

    // --- Props ---
    const { 
      targetTrade, 
      checkedList,
      onCheckedChange
    } = this.props

    // --- Columns ---
    const columns: Object[] = [{
      title: 'Symbol',
      dataIndex: 'OptionSymbol',
      key: 'OptionSymbol',
      render: (text, record) => {
        return <span title={record.OptionSymbol}>{text}</span>
      }
    }, {
      title: 'Trade Date',
      dataIndex: 'OpenDate',
      key: 'OpenDate',
      render: (text, record, index) => {
        if (editableIndexes.indexOf(index) > -1) {
          return <DatePicker value={text ? moment(text) : ''} onChange={(e, string) => this.props.onChangeTransactionValues('tradeDate', string, index)} />;
        } else {
          return text ? moment(text).format('YYYY-MM-DD') : '';
        }
      }
    }, {
      title: 'Strike',
      dataIndex: 'Strike',
      key: 'Strike',
      render: (text, record, index) => {
        if (editableIndexes.indexOf(index) > -1) {
          return <InputNumber value={text} onChange={(e) => this.props.onChangeTransactionValues('strike', e, index)} />;
        } else {
          return text;
        }
      }
    }, {
      title: 'Quantity',
      dataIndex: 'Qty',
      key: 'Qty',
      render: (text, record, index) => {
        if (editableIndexes.indexOf(index) > -1) {
          return <InputNumber value={text} onChange={(e) => this.props.onChangeTransactionValues('quantity', e, index)} />;
        } else {
          return text;
        }
      }
    }, {
      title: 'Expiration',
      dataIndex: 'ExpirationDate',
      key: 'ExpirationDate',
      render: (text, record, index) => {
        if (editableIndexes.indexOf(index) > -1) {
          return <DatePicker value={text ? moment(text) : ''} onChange={(e, string) => this.props.onChangeTransactionValues('expiration', string, index)} />;
        } else {
          return text ? moment(text).format('YYYY-MM-DD') : '';
        }
      }
    }, {
      title: 'Expiration Days',
      dataIndex: 'DaysToExpire',
      key: 'DaysToExpire',
    }, {
      title: 'IV',
      dataIndex: 'ImpliedVolatility',
      key: 'ImpliedVolatility',
      render: (text, record, index) => {
        if (editableIndexes.indexOf(index) > -1) {
          return <Input value={text} onChange={(e) => this.props.onChangeTransactionValues('iv', e.target.value, index)} />;
        } else {
          return text;
        }
      }
    },{
      title: 'Avg Price',
      dataIndex: 'AveragePrice',
      key: 'AveragePrice',
      render: (text, record, index) => {
        if (editableIndexes.indexOf(index) > -1) {
          return <InputNumber value={text} type="numeric" onChange={(e) => this.props.onChangeTransactionValues('price', e, index)} />;
        } else {
          return (text && !isNaN(text) ? parseFloat(text).toFixed(2) : '')
        }
      }
    },{
      title: 'Market Price',
      dataIndex: 'marketPrice',
      key: 'marketPrice',
      render: (text, record, index) => {
        if (editableIndexes.indexOf(index) > -1) {
          return <InputNumber value={text} type="numeric" onChange={(e) => this.props.onChangeTransactionValues('marketPrice', e, index)} />;
        } else {
          return text;
        }
      }
    }, {
      title: 'Side',
      dataIndex: 'TradeType',
      key: 'TradeType',
      render: (text, record, index) => {
        if (editableIndexes.indexOf(index) > -1) {
          return <Select defaultValue={text} value={text}
                         onChange={(e) => this.props.onChangeTransactionValues('assetType', e, index)}
                         style={{width: 100}}>
            <Option value="Call">Call</Option>
            <Option value="Put">Put</Option>
          </Select>
            ;
        } else {
          return text;
        }
      }
    },
      // {
      //   title: 'Operation',
      //   dataIndex: 'Operation',
      //   key: 'Operation',
      //   width: 100,
      //   render: (text, record, index) => {
      //     if (editableIndexes.indexOf(index) > -1) {
      //       return <a onClick={() => this.onCancel(index)}>Cancel</a>
      //     } else {
      //       return <a onClick={() => this.onEdit(index)}>Edit</a>
      //     }
      // }}
      ]


    // --- Select Box ---
    const rowSelection = {
      onChange: selectedRowKeys => onCheckedChange(selectedRowKeys),
      selectedRowKeys: checkedList
    }
    
    const rows = ConvertTransactionToPositions((targetTrade.transactions || []).filter(x => x.quantity !== 0))
    console.log(rows);
    return (
      <StyledCard
        loading={!targetTrade.transactions}
        bordered={false}
        title={`Selected Trade: ${targetTrade.name || ''}`}>
        <Table
          dataSource={rows}
          rowSelection={rowSelection}
          size="small"
          columns={columns}
          pagination={false} />
      </StyledCard>
    )
  }
}

export default TableRiskSelected



// WEBPACK FOOTER //
// ./src/components/table-risk-selected/index.js